"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipoMaterialDescricao = void 0;
var bson_1 = require("bson");
var TipoMaterialDescricao = /** @class */ (function () {
    function TipoMaterialDescricao(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.TIPO_MAT, TIPO_MAT = _c === void 0 ? '' : _c, _d = _a.DESCRICAO, DESCRICAO = _d === void 0 ? '' : _d;
        this._id = _id;
        this.TIPO_MAT = TIPO_MAT;
        this.DESCRICAO = DESCRICAO;
    }
    return TipoMaterialDescricao;
}());
exports.TipoMaterialDescricao = TipoMaterialDescricao;
//# sourceMappingURL=TipoMaterialDescricao.js.map